/**
 * redirect/returnUrl 안전성 검증 — open-redirect 방어.
 * '/' 로 시작하는 내부 경로만 허용('//evil.com'·'/\evil.com' 변형 차단).
 * @returns 안전한 내부 경로, 아니면 null(호출부가 기본 목적지로 대체).
 */
export function safeInternalPath(value: unknown): string | null {
  return typeof value === 'string' && value.startsWith('/') && value[1] !== '/' && value[1] !== '\\'
    ? value
    : null;
}
